// Phase I0.3 — CategoryChip primitive.
// 11px JetBrains Mono uppercase chip, padded 3×6, color-coded per the
// CATEGORY enum. Renders the glyph + label or short code.

import type { CSSProperties } from "react";
import {
  CATEGORY,
  categoryColor,
  categoryGlyph,
  type CategoryId,
} from "../../super-acca/categories";

export interface CategoryChipProps {
  /** Category id (case-insensitive). */
  category: string;
  /** Render the 3-letter short instead of the full label. */
  short?: boolean;
  style?: CSSProperties;
}

export function CategoryChip({ category, short, style }: CategoryChipProps) {
  const upper = category.toUpperCase() as CategoryId;
  const def = CATEGORY[upper];
  const color = categoryColor(category);
  const glyph = categoryGlyph(category);
  const label = def ? (short ? def.short : def.label) : category.toUpperCase();
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        padding: "3px 6px",
        borderRadius: 2,
        fontFamily: "var(--sa-font-mono)",
        fontSize: 11,
        letterSpacing: "0.16em",
        textTransform: "uppercase",
        color,
        background: `${color}14`,
        border: `1px solid ${color}33`,
        lineHeight: 1,
        ...style,
      }}
    >
      <span aria-hidden>{glyph}</span>
      {label}
    </span>
  );
}
